import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../css/Login.css'
import apiClient from '@/api/client';

const Login = () => {
    const [values, setValues] = useState({
        email: '',
        password: ''
    });
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);

        try {
            const response = await apiClient.post('/login', {
                email: values.email,
                password: values.password
            });

            if (response.data.message === "Login successful") {
                const user = response.data.user;
                
                // Store basic user info
                localStorage.setItem('token', response.data.token);
                localStorage.setItem('id', user.id);
                localStorage.setItem('user_name', user.name);
                
                // Store roles instead of user_type
                if (user.roles && Array.isArray(user.roles)) {
                    localStorage.setItem('roles', JSON.stringify(user.roles));
                }
                
                // Build access_area from roles
                const accessArea = {};
                if (user.roles && Array.isArray(user.roles)) {
                    user.roles.forEach(role => {
                        accessArea[role.name] = 1;
                    });
                }
                localStorage.setItem('access_area', JSON.stringify(accessArea));

                // Optional: Store user_type for backward compatibility during transition
                // Can be removed later
                if (user.user_type) {
                    localStorage.setItem('user_type', user.user_type);
                }

                // Redirect based on roles
                if (user.roles?.some(role => role.name === 'admin')) {
                    navigate('/admin');
                } else if (user.roles?.length > 0) {
                    navigate('/admin'); // Coordinators also go to admin panel
                } else {
                    navigate('/'); // Regular users go to homepage
                }
            } else {
                alert('Login failed. Please check your credentials.');
            }
        } catch (error) {
            console.error('Error during login:', error);
            if (error.response?.data?.message) {
                alert(error.response.data.message);
            } else {
                alert('An error occurred during login. Please try again.');
            }
        } finally {
            setIsLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setValues((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    };

    return (
        <div className='text-center login-page'>
            <form onSubmit={handleSubmit}>
                <div className="mt-6">Login Page</div>
                <div className="form-item mt-5">
                    <input 
                        type="email" 
                        id="email" 
                        name="email" 
                        onChange={handleInputChange} 
                        required 
                        disabled={isLoading}
                    />
                    <br />
                    <label htmlFor="email">Email</label>
                </div>
                <div className="form-item mt-5">
                    <input 
                        type="password" 
                        id="password" 
                        name="password" 
                        onChange={handleInputChange} 
                        required 
                        disabled={isLoading}
                    />
                    <br />
                    <label htmlFor="password">Password</label>
                </div>
                <div className='mt-5'>
                    <Link to="/register">Register</Link>
                </div>
                <button 
                    type='submit' 
                    className='loginButton' 
                    disabled={isLoading}
                >
                    {isLoading ? 'Signing in...' : 'Sign In'}
                </button>
            </form>
        </div>
    );
};

export default Login;